module.exports = __webpack_public_path__ + "static/media/mine.b453b476.png";